import styled from '@emotion/styled';
import { LoginContext } from 'features/auth/types';

import { CenterContainer } from './CenterContainer';
import { Trans } from '@lingui/macro';
import { SignIn } from '@phosphor-icons/react';
import { CircularProgress } from '@mui/material';
import { getUserData } from 'features/auth';
import { Text } from 'components/text/Text';
import { BaseButton, Button } from 'components/button/Button';

type SwitchCompanyProps = {
  onSelectCompany: (loginContext: LoginContext, length: number) => void;
  onLogout: () => void;
  isLoading: boolean;
};

export const SwitchCompanyForm = ({
  onSelectCompany,
  onLogout,
  isLoading = false,
}: SwitchCompanyProps) => {
  const user = getUserData();

  return (
    <CenterContainer
      welcomeText={
        <Text variant="bodyMd" fontFamily="Gazpacho">
          <Trans>... Welcome back</Trans>
        </Text>
      }
    >
      <List>
        <SelectContainer>
          <Header>
            <Trans>Select Company</Trans>
          </Header>
          {isLoading ? <CircularProgress /> : null}
          {!isLoading &&
            user?.userData?.loginContexts?.map((loginContext: LoginContext) => (
              <BaseButton
                key={loginContext?.id}
                onClick={() =>
                  onSelectCompany(loginContext, user?.userData?.loginContexts?.length || 0)
                }
              >
                <SignIn />{' '}
                <Name>
                  {loginContext?.organizationName}
                  {loginContext?.organizationType === 2 ? ' (Supplier)' : ''}
                </Name>
              </BaseButton>
            ))}
        </SelectContainer>
        <Logout>
          <Button color="primary" variant="contained" onClick={() => onLogout()}>
            Log out
          </Button>
        </Logout>
      </List>
    </CenterContainer>
  );
};

const SelectContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const Name = styled.span`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Logout = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

const List = styled.div`
  margin: 16px 24px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  button {
    padding: 8px 12px;
    border-radius: 4px;
    margin-bottom: 8px;
  }
`;

const Header = styled.h1`
  margin-bottom: 16px;
  color: ${p => p.theme.palette.text.primary};
  font-weight: 600;
  font-size: 1.125rem;
`;
